import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MapMarkerIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 70 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_19790_23596)">
        <path
          d="M34.6201 10C47.1129 10 57.2402 20.1274 57.2402 32.6201C57.2402 43.2245 49.9426 52.123 40.0957 54.5713L35.7539 59.5859C35.1558 60.2766 34.0845 60.2766 33.4863 59.5859L29.1436 54.5713C19.2971 52.1227 12 43.2242 12 32.6201C12 20.1274 22.1274 10 34.6201 10Z"
          fill="#1B3029"
        />
      </g>
      <path
        d="M34.7261 22.0645C30.5101 22.0645 27.0801 25.4944 27.0801 29.7104C27.0801 34.9426 33.9225 42.6237 34.2138 42.9482C34.4875 43.2529 34.9652 43.2524 35.2383 42.9482C35.5297 42.6237 42.3721 34.9426 42.3721 29.7104C42.372 25.4944 38.9421 22.0645 34.7261 22.0645ZM34.7261 33.5573C32.6049 33.5573 30.8792 31.8316 30.8792 29.7104C30.8792 27.5892 32.6049 25.8636 34.7261 25.8636C36.8472 25.8636 38.5729 27.5893 38.5729 29.7105C38.5729 31.8317 36.8472 33.5573 34.7261 33.5573Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_19790_23596"
          x="0"
          y="0"
          width="69.2402"
          height="74.1035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.105882 0 0 0 0 0.188235 0 0 0 0 0.160784 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19790_23596" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19790_23596" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})

MapMarkerIcon.displayName = 'MapMarkerIcon'
